export default __webpack_public_path__ + "static/media/Series-S-1.87621c2f.jpg";